(function () {
  'use strict';

  var config = window.CREG_OPENAI_ADS || {};
  if (!config.pixelId) return;

  if (!window.oaiq) {
    var queue = function () { queue.q.push(arguments); };
    queue.q = [];
    window.oaiq = queue;
    var sdk = document.createElement('script');
    sdk.async = true;
    sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(sdk, firstScript);
  }

  function measurementAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
      return Boolean(privacy.analyticsProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  var measured = false;

  function measurePage() {
    if (measured || !measurementAllowed()) return;
    measured = true;

    window.oaiq('measure', 'page_viewed', {
      type: 'contents',
      contents: [{
        id: String(config.page && config.page.id || window.location.pathname),
        name: String(config.page && config.page.name || document.title),
        content_type: String(config.page && config.page.contentType || 'page')
      }]
    });

    if (config.product && config.product.id) {
      var product = {
        id: String(config.product.id),
        name: String(config.product.name || ''),
        content_type: 'product'
      };
      if (Number.isInteger(config.product.amount) && config.product.amount >= 0) {
        product.amount = config.product.amount;
        product.currency = config.product.currency;
      }
      window.oaiq('measure', 'contents_viewed', {
        type: 'contents',
        contents: [product]
      });
    }
  }

  var allowed = measurementAllowed();
  window.oaiq('consent', allowed);
  window.oaiq('init', {
    pixelId: String(config.pixelId),
    debug: Boolean(config.debug)
  });
  if (allowed) measurePage();

  document.addEventListener('visitorConsentCollected', function () {
    var nextAllowed = measurementAllowed();
    window.oaiq('consent', nextAllowed);
    if (nextAllowed) measurePage();
  });
}());
